export default __webpack_public_path__ + "static/media/fullstackArchitecture.c324feb4.md";